export default "__VITE_PUBLIC_ASSET__6519f12d__"